/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Algo } from '../models/algo';
@Injectable({
  providedIn: 'root',
})
class AlgoService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `AlgoService.AlgoListParams` containing the following parameters:
   *
   * - `updated_by`:
   *
   * - `status`:
   *
   * - `search`: A search term.
   *
   * - `run_algos`:
   *
   * - `owner`:
   *
   * - `ordering`: Which field to use when ordering the results.
   *
   * - `offset`: The initial index from which to return the results.
   *
   * - `name`:
   *
   * - `limit`: Number of results to return per page.
   *
   * - `id`:
   *
   * - `description`:
   */
  algoListResponse(params: AlgoService.AlgoListParams): __Observable<__StrictHttpResponse<{count: number, next?: null | string, previous?: null | string, results: Array<Algo>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.updatedBy != null) __params = __params.set('updated_by', params.updatedBy.toString());
    if (params.status != null) __params = __params.set('status', params.status.toString());
    if (params.search != null) __params = __params.set('search', params.search.toString());
    if (params.runAlgos != null) __params = __params.set('run_algos', params.runAlgos.toString());
    if (params.owner != null) __params = __params.set('owner', params.owner.toString());
    if (params.ordering != null) __params = __params.set('ordering', params.ordering.toString());
    if (params.offset != null) __params = __params.set('offset', params.offset.toString());
    if (params.name != null) __params = __params.set('name', params.name.toString());
    if (params.limit != null) __params = __params.set('limit', params.limit.toString());
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.description != null) __params = __params.set('description', params.description.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/algo/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{count: number, next?: null | string, previous?: null | string, results: Array<Algo>}>;
      })
    );
  }
  /**
   * @param params The `AlgoService.AlgoListParams` containing the following parameters:
   *
   * - `updated_by`:
   *
   * - `status`:
   *
   * - `search`: A search term.
   *
   * - `run_algos`:
   *
   * - `owner`:
   *
   * - `ordering`: Which field to use when ordering the results.
   *
   * - `offset`: The initial index from which to return the results.
   *
   * - `name`:
   *
   * - `limit`: Number of results to return per page.
   *
   * - `id`:
   *
   * - `description`:
   */
  algoList(params: AlgoService.AlgoListParams): __Observable<{count: number, next?: null | string, previous?: null | string, results: Array<Algo>}> {
    return this.algoListResponse(params).pipe(
      __map(_r => _r.body as {count: number, next?: null | string, previous?: null | string, results: Array<Algo>})
    );
  }

  /**
   * @param data undefined
   */
  algoCreateResponse(data: Algo): __Observable<__StrictHttpResponse<Algo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/algo/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Algo>;
      })
    );
  }
  /**
   * @param data undefined
   */
  algoCreate(data: Algo): __Observable<Algo> {
    return this.algoCreateResponse(data).pipe(
      __map(_r => _r.body as Algo)
    );
  }

  /**
   * @param id A unique integer value identifying this algo.
   */
  algoReadResponse(id: number): __Observable<__StrictHttpResponse<Algo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/algo/${id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Algo>;
      })
    );
  }
  /**
   * @param id A unique integer value identifying this algo.
   */
  algoRead(id: number): __Observable<Algo> {
    return this.algoReadResponse(id).pipe(
      __map(_r => _r.body as Algo)
    );
  }

  /**
   * @param params The `AlgoService.AlgoUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this algo.
   *
   * - `data`:
   */
  algoUpdateResponse(params: AlgoService.AlgoUpdateParams): __Observable<__StrictHttpResponse<Algo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.data;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/algo/${params.id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Algo>;
      })
    );
  }
  /**
   * @param params The `AlgoService.AlgoUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this algo.
   *
   * - `data`:
   */
  algoUpdate(params: AlgoService.AlgoUpdateParams): __Observable<Algo> {
    return this.algoUpdateResponse(params).pipe(
      __map(_r => _r.body as Algo)
    );
  }

  /**
   * @param params The `AlgoService.AlgoPartialUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this algo.
   *
   * - `data`:
   */
  algoPartialUpdateResponse(params: AlgoService.AlgoPartialUpdateParams): __Observable<__StrictHttpResponse<Algo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.data;
    let req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl + `/algo/${params.id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Algo>;
      })
    );
  }
  /**
   * @param params The `AlgoService.AlgoPartialUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this algo.
   *
   * - `data`:
   */
  algoPartialUpdate(params: AlgoService.AlgoPartialUpdateParams): __Observable<Algo> {
    return this.algoPartialUpdateResponse(params).pipe(
      __map(_r => _r.body as Algo)
    );
  }

  /**
   * @param id A unique integer value identifying this algo.
   */
  algoDeleteResponse(id: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/algo/${id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id A unique integer value identifying this algo.
   */
  algoDelete(id: number): __Observable<null> {
    return this.algoDeleteResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module AlgoService {

  /**
   * Parameters for algoList
   */
  export interface AlgoListParams {
    updatedBy?: string;
    status?: string;

    /**
     * A search term.
     */
    search?: string;
    runAlgos?: string;
    owner?: string;

    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;

    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    name?: string;

    /**
     * Number of results to return per page.
     */
    limit?: number;
    id?: number;
    description?: string;
  }

  /**
   * Parameters for algoUpdate
   */
  export interface AlgoUpdateParams {

    /**
     * A unique integer value identifying this algo.
     */
    id: number;
    data: Algo;
  }

  /**
   * Parameters for algoPartialUpdate
   */
  export interface AlgoPartialUpdateParams {

    /**
     * A unique integer value identifying this algo.
     */
    id: number;
    data: Algo;
  }
}

export { AlgoService }
